import { CSSTransition } from 'react-transition-group';
import { CSSTransitionProps } from 'react-transition-group/CSSTransition';

const enterTimeout = 350;
const leaveTimeout = 270;

export enum Transition {
    FadeDown = 'fade-down',
    FadeIn = 'fade-in',
    FadeUp = 'fade-up',
}

export const AlertTransition = ({ transition, ...props }: Partial<CSSTransitionProps> & { transition: Transition }) => (
    <CSSTransition {...props} classNames={transition} timeout={{ enter: enterTimeout, exit: leaveTimeout }} />
);
